module.exports = __webpack_public_path__ + "media/images/design/common/images/menu03-e23a8df62044bb027b0b864ad2982957.jpg";